export default __webpack_public_path__ + "3e7deddb254e39745a6c9a268370a6de.png";